import { render, staticRenderFns } from "./ObjectCardClue.vue?vue&type=template&id=27e57dad&scoped=true&"
import script from "./ObjectCardClue.vue?vue&type=script&lang=js&"
export * from "./ObjectCardClue.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardClue.vue?vue&type=style&index=0&id=27e57dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e57dad",
  null
  
)

export default component.exports